export default "Not found :(\n"